import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import CivilStatusForm from './form';
import {
  CommonInterfaceSubscription,
  CivilStatusVM,
} from 'subscription/view-models/common-interface-subscription';

interface CivilStatusProps {
  isCitizenship?: boolean;
  disabled?: boolean;
}

const CivilStatusComponent = ({
  isCitizenship = false,
  disabled = false,
}: CivilStatusProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<CommonInterfaceSubscription>();

  const onFieldCivilStatusChange = useEventCallback(
    (key: keyof CivilStatusVM, value: CivilStatusVM[keyof CivilStatusVM]) => {
      formContext.setFieldValue('civilStatus', {
        ...(formContext.values.civilStatus || {}),
        [key]: value,
      });
    }
  );

  return isCitizenship ? (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-civil-status-content"
        id="panel-person-civil-status-header"
        expandIcon={<ExpandMore />}
      >
        {disabled ? undefined : formContext.errors.civilStatus ? (
          <Close color="error" />
        ) : (
          <Check color="success" />
        )}
        <Typography>Stato Civile</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CivilStatusForm
          disabled={disabled}
          values={formContext.values.civilStatus}
          onChange={onFieldCivilStatusChange}
          errors={formContext.errors.civilStatus as FormikErrors<CivilStatusVM>}
          touched={formContext.touched.civilStatus as unknown as FormikTouched<CivilStatusVM>}
        />
      </AccordionDetails>
    </Accordion>
  ) : (
    <></>
  );
};

CivilStatusComponent.displayName = 'Accordion civil status component';

const CivilStatus = memo(CivilStatusComponent);

export default CivilStatus;
